import { FileEntryFM, parseDate, parseSize } from '@bm-js/atlascloud-shared'
import { Button } from '@bm-js/atlascloud-ui'
import { useMemo } from 'react'
import MediaLibraryColumns from './MediaLibraryColumns'
import MediaItemDeleteButton from './MediaItemDeleteButton'
import MediaItemThumbnail from './MediaItemThumbnail'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  file: FileEntryFM
  handleSelect?: (file: FileEntryFM) => void
  handleDelete?: (file: FileEntryFM) => void
  setSpotlight: (file: FileEntryFM) => void
  openFile: (file: FileEntryFM) => void
  index: number
}

const MediaItem = ({
  file,
  handleSelect,
  handleDelete,
  setSpotlight,
  openFile,
  index,
}: Props) => {
  const { tr } = useTr()

  const bgClass = useMemo(() => {
    if (index % 2 === 0) return 'bg-primary-200/50'
    return 'bg-primary-200/30'
  }, [index])

  const fileType = useMemo(() => {
    const [type, subType] = file.contentType.split('/')
    const ext = file.name.split('.')[1]
    if (type === 'image') return subType
    return ext
  }, [file.contentType, file.name])

  const actionItem = useMemo(() => {
    if (handleSelect)
      return (
        <Button onClick={() => handleSelect(file)}>{tr(TrKey.select)}</Button>
      )
    if (handleDelete)
      return <MediaItemDeleteButton file={file} deleteFile={handleDelete} />
    return null
  }, [handleDelete, handleSelect, file, tr])

  return (
    <MediaLibraryColumns
      extraParentClass={bgClass}
      contents={[
        <MediaItemThumbnail
          file={file}
          setSpotlight={setSpotlight}
          openFile={openFile}
        />,
        <p className='m0 truncate'>{file.name}</p>,
        <p className='m0'>{parseSize(file.size)}</p>,
        <p className='m0'>{fileType}</p>,
        <p className='m0'>{parseDate(file.uploadedAt)}</p>,
        actionItem,
      ]}
    />
  )
}

export default MediaItem
